var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7721 14.5794L0 25.3175L15.6724 40.9405L26.4445 30.2024L10.7721 14.5794Z",
    fill: "url(#paint0_linear_4374_9879)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7668 54.4354L48.0903 57.1029L41.5705 63.5893C40.6898 64.4671 39.2714 64.4671 38.3907 63.5893L25.374 50.6165L36.1488 39.878L50.7554 54.4354H50.7668Z",
    fill: "#0046CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3846 39.8723L54.6113 50.6092L69.2264 65.175L79.9996 54.4381L65.3846 39.8723Z",
    fill: "url(#paint1_linear_4374_9879)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0226 29.4122L44.112 40.2444L29.3213 25.56L38.6799 16.2687C39.5601 15.4637 40.9153 15.4637 41.784 16.2687L46.4864 20.9373L51.1309 25.5485L55.0226 29.4122Z",
    fill: "#0046CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9919 25.3206L54.6106 50.6165L50.7673 54.4467L48.0908 57.1143L41.571 63.6007C40.6903 64.4784 39.2719 64.4784 38.3912 63.6007L29.2178 54.4467L39.9925 43.7197L43.8358 39.8894L54.6106 29.1509L69.2286 14.5935L79.9919 25.332V25.3206Z",
    fill: "#0057FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7666 25.3206L40.0033 36.0591L36.16 39.8894L25.3853 50.6279L10.7673 65.1852L0.00390625 54.4468L14.6219 39.8894L25.3967 29.1509L29.2399 25.3206L38.4248 16.1667C38.4477 16.1439 38.4706 16.1325 38.482 16.1097C39.3513 15.3117 40.6896 15.3117 41.5474 16.1097C41.5703 16.1325 41.5932 16.1439 41.6046 16.1667L46.1913 20.7494L50.7781 25.3206H50.7666Z",
    fill: "#0057FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4374_9879",
    x1: 19.7811,
    y1: 34.208,
    x2: 0.439327,
    y2: 15.1075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#46AFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4374_9879",
    x1: 61.1756,
    y1: 46.5162,
    x2: 79.1993,
    y2: 64.3377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3AA0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.05b1d55cfab90a32ecabc19fb67f7293.svg";
export { ForwardRef as ReactComponent };